<template>
  <el-dropdown style="margin: 0 18px" trigger="click" hide-on-click>
    <span class="el-dropdown-link">

      {{ sysUserName }}
      <el-avatar :size="24" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" style="margin-left: 8px;"></el-avatar>
<!--      <ElIcons name="CaretBottom" style="margin-left: 4px;"/>-->
    </span>
    <template #dropdown>
      <el-dropdown-menu>
<!--        <el-dropdown-item>-->
<!--          <ElIcons name="EditPen" style="margin-right: 12px;"/>修改密码-->
<!--        </el-dropdown-item>-->
        <el-dropdown-item @click="logout">
          <ElIcons name="SwitchButton" style="margin-right: 12px;"/>退出登陆
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
import { signOut, addOrUpdateUser } from '@/api/url'
import { getFormData } from '@/api/api'
export default {
  name: "UserInfo",
  data() {
    return {
      sysUserName: JSON.parse(sessionStorage.getItem('account'))
    }
  },
  methods: {
    logout() {
      var _this = this;
      getFormData(signOut).then(() => {
        sessionStorage.removeItem('account');
        localStorage.removeItem('menuList');
        sessionStorage.removeItem('navArray');
        _this.$store.dispatch('delAllViews')
        _this.$router.push('/');
      })
    }
  }
}
</script>

<style scoped>

</style>
